import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import Layout from "@/_LayoutsRelated/layout/Layout";
import { CDN_LINK } from "@globalConfig";
import { useTranslation } from "@i18n";
import useApi from "@hooks/useApi";
import Loader from "@componentsShared/Loader/Loader";
import HorizontalCarCard from "@/components/sharedComponents/HorizontalCarCard/HorizontalCarCard";
import { api__getProductDetails } from "@/apis/finance-eligibility/api__checkFinanceEligibility";
import useHelpers from "@hooks/useHelpers";
import { useLang } from "@/common/Contexts/LanguageContext";
var FinanceQualifiedPost = function FinanceQualifiedPost(_ref) {
  var _data$;
  var post_id = _ref.post_id;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var lang = useLang();
  var layoutOptions = {
    hideOrangeHeadBtn: true,
    hideFooter: true,
    hideSideMenue: false,
    hideAppBanner: true,
    mobileNoLogo: true,
    hideHeaderOnmobile: true,
    headHideLinks: true,
    backgroundColor: "bg-gray-lotion",
    custommobileHeader: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center px-4 py-5 bg-white border-b border-b-gray-gainsboro border-solid min-h-[70px]"
    }))
  };
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var _useApi = useApi([post_id], /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            return _context.a(2, api__getProductDetails(post_id));
        }
      }, _callee);
    }))),
    _useApi2 = _slicedToArray(_useApi, 3),
    loading = _useApi2[0],
    error = _useApi2[1],
    data = _useApi2[2];
  if (loading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  return /*#__PURE__*/React.createElement(Layout, layoutOptions, /*#__PURE__*/React.createElement("section", {
    className: "bg-gray-lotion min-h-[calc(100vh-70px)] pt-8 lg:max-w-[480px]  mx-auto lg:bg-white lg:px-0 px-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/quialified.png",
    alt: "Financing eligibility approved"
  })), /*#__PURE__*/React.createElement("div", {
    className: "mt-4 mb-7 flex flex-col items-center gap-3"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-primary font-bold text-2xl text-center sss"
  }, t("eligible_financing_2", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-center text-primary font-semibold text-base flex gap-0.5 flex-wrap justify-center"
  }, /*#__PURE__*/React.createElement("span", null, t("like_submit_financing_application", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("span", null, data === null || data === void 0 ? void 0 : (_data$ = data[0]) === null || _data$ === void 0 ? void 0 : _data$.title), /*#__PURE__*/React.createElement("span", null, lang === 'ar' ? "؟" : "?"))), /*#__PURE__*/React.createElement("div", {
    className: "lg:max-w-[370px] mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mt-3"
  }, /*#__PURE__*/React.createElement(HorizontalCarCard, {
    post: data === null || data === void 0 ? void 0 : data[0],
    page: 1,
    hideFavIcon: true,
    referralLocation: "recommendation_filter",
    enableLinkClick: false
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4 mt-6 px-3 lg:px-0"
  }, /*#__PURE__*/React.createElement("button", {
    className: " cursor-pointer p-3 rounded bg-primary border-0 outline-none text-white text-sm font-bold leading-8",
    onClick: function onClick() {
      navigateTo("/pre-checkout/".concat(post_id));
    }
  }, t("submit_financing_application", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("button", {
    className: " cursor-pointer p-3 rounded bg-transparent border border-solid border-primary outline-none text-primary text-sm font-bold leading-8",
    onClick: function onClick() {
      var eligibilityData = JSON.parse(sessionStorage.getItem("eligibility_data") || null);
      var filters = eligibilityData === null || eligibilityData === void 0 ? void 0 : eligibilityData.filters;
      var url = "/filters" + "?" + filters;
      navigateTo(url);
    }
  }, t("view_cars", {
    ns: "web_common"
  }))))));
};
export default FinanceQualifiedPost;